import angular from "angular";

import BicycleOwnerRequestsModuleRouting from "./bicycle-owner-requests.module.routing";

export default angular
  .module("vt-bicycle-owner-requests", [])
  .config(BicycleOwnerRequestsModuleRouting);
